import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles, withStyles } from '@material-ui/styles';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
  TablePagination,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
  Grid
} from '@material-ui/core';

import Autocomplete from '@material-ui/lab/Autocomplete';

import { SIREN_CONFIG, SIREN_COLOR } from "config.js";
import DateFnsUtils from '@date-io/date-fns'; //yarn add date-fns
import moment from 'moment';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker
} from '@material-ui/pickers';

import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { createMuiTheme } from "@material-ui/core/styles";
import { useSelector } from 'react-redux';
import { loadRoomList } from "utils/LoadConfiguration";
import { FormattedMessage, useIntl } from "react-intl";

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  updateQueryWakeupStartDate,
  updateQueryWakeupStartTime,
  updateQueryWakeupRoomId,
  updateQueryCheckWakeup,
  updateQueryCheckPresence,
  } from 'actions/query';



const theme = createMuiTheme({
  overrides: {
    MuiInputBase: {
      input: {
        //   background: '#dd7711',
        //   padding: 10,
        fontSize: '16px',
      },
    },
  },
})


const WakeupTextTypography = withStyles({
  root: {
    backgroundColor: SIREN_COLOR.WAKEUP_BG2_COLOR,
  }
})(Typography);


const PresenceTextTypography = withStyles({
  root: {
    backgroundColor: SIREN_COLOR.ACTIVITY_BG2_COLOR,
  }
})(Typography);


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}


function getComparator(order, orderBy) {
  // console.log("order : " + order + " , orderBy: " + orderBy);
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}


function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const COLUMN_WIDTH = {
  NO: '10%',
  ROOM_NAME: '50%',
  STATUS_LABEL: '20%', //35
  EVENTTIME: '20%', //45
}

const headCells = [
  { id: 'no', numeric: false, label: 'No', width: COLUMN_WIDTH.NO, align: 'center' },
  { id: 'roomName', numeric: false, label: <FormattedMessage id="emergency_history_room" />, width: COLUMN_WIDTH.ROOM_NAME, align: 'center' },
  { id: 'status_Label', numeric: false, label: <FormattedMessage id="emergency_history_status" />, width: COLUMN_WIDTH.STATUS_LABEL, align: 'center' },
  { id: 'eventTime', numeric: false, label: <FormattedMessage id="emergency_history_occurTime" />, width: COLUMN_WIDTH.EVENTTIME, align: 'center' },
];


function EnhancedTableHeader(props) {

  const { classes, order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  }

  return (
    <TableHead>
      <TableRow>
        {
          headCells.map((headCell) => (
            <TableCell key={headCell.id}
              // align={headCell.numeric ? 'right': 'left'}
              align={headCell.align}
              width={headCell.width}
              sortDirection={orderBy === headCell.id ? order : false}
            >

              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? '' : ''}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}


EnhancedTableHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired
}


function TwoPartTable(props) {
  const { formatMessage } = useIntl();
  const { module } = props;

  return (
    <TableRow
      hover
      tabIndex={-1}
      key={module.eventId}
    >
      <TableCell width={COLUMN_WIDTH.NO} align="center">
        <Typography variant="body1">{module._id}</Typography>
      </TableCell>
      <TableCell width={COLUMN_WIDTH.ROOM_NAME} align="left">{module.roomName}&nbsp;-&nbsp;{module.installed_pos_detail}</TableCell>

      <TableCell width={COLUMN_WIDTH.STATUS_LABEL} align="center">
        {module.type.includes('wakeup') ?
          (<WakeupTextTypography>{formatMessage({ id: module.type })}</WakeupTextTypography>) :
          (<PresenceTextTypography>{formatMessage({ id: module.type })}</PresenceTextTypography>)
        }</TableCell>

      <TableCell width={COLUMN_WIDTH.EVENTTIME} align="center">{moment(module.eventTime).format('MM.DD HH:mm')}</TableCell>
    </TableRow>
  );
}


const StartDateDefaultValue = new Date( (new Date()).valueOf() - (1000 * 60 * 60 * 24) );
// const StartTimeDefaultValue = moment().format('HH:mm');
const StartTimeDefaultValue = new Date( (new Date()).valueOf() - (1000 * 60 * 60 * 24) );


//지정한 검색일자의 최근 2일을 최대 검색 기간으로 하자.
//더 길어지면 서버 부하가 발생함.
const WakeupList = props => {
  const { className, queryParams, ...rest } = props;

  const classes = useStyles();
  const { formatMessage } = useIntl();

  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('eventTime');

  const [firstHalfRowsPerPage, setFirstHalfRowsPerPage] = useState(10);
  const [secondHalfRowsPerPage, setSecondHalfRowsPerPage] = useState(10);
  const [firstHalfPage, setFirstHalfPage] = useState(0);
  const [secondHalfPage, setSecondHalfPage] = useState(0);

  const [startDate, setStartDate] = useState(StartDateDefaultValue);
  const [startTime, setStartTime] = useState(StartTimeDefaultValue);

  const [firstHalfListData, setFirstHalfListData] = useState([]);
  const [secondHalfListData, setSecondHalfListData] = useState([]);

  const [checkedWakeup, setCheckedWakeup] = useState(true);
  const [checkedPresence, setCheckedPresence] = useState(false);

  const facility_id = useSelector((store) => store.user.facility_id);
  const [roomList, setRoomList] = useState([]);
  const [selectedRoomId, setSelectedRoomId] = useState('');


  const getRoomName = (roomId) => {
    var ret = {};
    roomList.forEach(room => {
      if (room.roomId === roomId) {
        ret = { roomId: room.roomId, roomName: room.roomName };
      }
    });
    return ret;
  }

  const handleStartDateChange = (date) => {
    setStartDate(date);
    props.updateQueryWakeupStartDate(date);
  }

  const handleStartTimeChange = (value) => {
    setStartTime(value);
    props.updateQueryWakeupStartTime(value);
  }

  const handleCheckWakeup = event => {
    setCheckedWakeup(event.target.checked);
    setCheckedPresence(!event.target.checked);

    props.updateQueryCheckWakeup(event.target.checked);
    props.updateQueryCheckPresence(!event.target.checked);
  }

  const handleCheckPresence = event => {
    setCheckedPresence(event.target.checked);
    setCheckedWakeup(!event.target.checked);

    props.updateQueryCheckPresence(event.target.checked);
    props.updateQueryCheckWakeup(!event.target.checked);
  }

  const searchData = (sDate, sTime, roomId, isWakeup, isPresence) => {

    //check parameters
    if (roomId === '') {
      alert(formatMessage({ id: "select_room" }));
      return;
    }

    if (isWakeup == false && isPresence == false){
      alert(formatMessage({id:'should_select_wakeup_or_presence'}));
      return false;
    }


    let url = `${SIREN_CONFIG.HOSTNAME}/event/queryWakeupList`;

    let params = {
      facility_id: facility_id,
      baseDate: moment(sDate).format('YYYY-MM-DD') + ' ' + sTime,
      roomId: roomId,
      isWakeup: isWakeup,
      isPresence: isPresence
    };

    url += '?' + (new URLSearchParams(params)).toString();
    // console.log(params);

    fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" }
    })
    .then((response) => { return response.json(); })
    .then((responseData) => {

      var list = [];
      var no = 1;

      if (responseData.resultCode === '000') {

        responseData.resultData.map(row => {
          row.no = no++;
          list.push(row);
        });

      } else {
        //params error
        alert(formatMessage({id:'wrong_parameters'}) + ': ' + JSON.stringify(responseData) );
      }


      //NOTE: 10개 넘으면 두 페이지로 표시하고, 그외는 한 페이지로 표시함
      if (list.length > 10) {
        const midIndex = Math.floor(list.length / 2); // 중간 인덱스 계산
        setFirstHalfListData(list.slice(0, midIndex));
        setSecondHalfListData(list.slice(midIndex));
      }else{
        setFirstHalfListData(list);
        setSecondHalfListData([]);
      }


      //자료가 없으면 alert 메시지 표시
      if (list.length  == 0) {
        alert(formatMessage({id:'not_data'}));
      }

      setFirstHalfPage(0);
      setSecondHalfPage(0);
    })
    .catch(error => {
      console.error(`Error Occur:`, error);
      alert('Error! ' + error.message)
    });

  }





  const handleSearch = event => {
    let sTime = '00:00';
    try{
      sTime = moment(startTime).format('HH:mm');
      searchData(startDate, sTime, selectedRoomId, checkedWakeup, checkedPresence);
    }catch(err){
      alert('wrong time');
    }
  }


  /**
   * 검색 정보 지우기
   * @param {*} event
   */
  const handleClear = event => {

    //오늘
    setStartDate(StartDateDefaultValue);
    setStartTime(StartTimeDefaultValue);
    setSelectedRoomId('');
    setCheckedWakeup(true);
    setCheckedPresence(false);

    setFirstHalfPage(0);
    setSecondHalfPage(0);

    setFirstHalfListData([]);
    setSecondHalfListData([]);
  }


  const handleFirstHalfPageChange = (event, page) => {
    setFirstHalfPage(page);
  };

  const handleSecondHalfPageChange = (event, page) => {
    setSecondHalfPage(page);
  };

  const handleFirstHalfRowsPerPageChange = event => {
    setFirstHalfRowsPerPage(event.target.value);
  };

  const handleSecondHalfRowsPerPageChange = event => {
    setSecondHalfRowsPerPage(event.target.value);
  };



  const firstHalfStartRow = (firstHalfPage * firstHalfRowsPerPage);
  const secondHalfStartRow = (secondHalfPage * secondHalfRowsPerPage);


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    console.log("property: " + property);
  };



  useEffect(() => {
    async function loadRoomInfo() {
      const list = await loadRoomList(facility_id);
      var list2 = [{ roomId: 'ALL', roomName: 'ALL' }, ...list];

      setRoomList(list2);
    }
    loadRoomInfo();


    //Loading the params
    if(queryParams.queryWakeupStartDate != ''){
      setStartDate( queryParams.queryWakeupStartDate);
    }

    if(queryParams.queryWakeupStartTime != ''){
      setStartTime( queryParams.queryWakeupStartTime);
    }

    if(queryParams.queryWakeupRoomId != ''){
      setSelectedRoomId(queryParams.queryWakeupRoomId);
    }

    setCheckedWakeup(queryParams.queryCheckWakeup);
    setCheckedPresence(queryParams.queryCheckPresence);


    return () => { };
  }, []);



  return (
    <Card className={clsx(classes.root, className)} {...rest} >

      <Box m={1} p={2}>
        <Box mt={2}
          display="flex"
          alignItems="center"
          justifyContent="start"
          flexGrow={1}>

          <div className={classes.input_container}>
            <FormattedMessage id="wakeup_table_search_label" />:&nbsp;
            <MuiThemeProvider theme={theme}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  autoOk
                  maxDate={moment()}
                  // maxDate={moment().subtract(1, "days")}
                  variant="inline"
                  // inputVariant="outlined"

                  id="date-picker-dialog_start"
                  format="yyyy-MM-dd"
                  fontSize="20"
                  value={startDate}
                  onChange={handleStartDateChange}
                  KeyboardButtonProps={{ 'aria-label': 'change date', }}
                  className={classes.datepicker}
                />


                <KeyboardTimePicker
                  // clearable
                  className={classes.textField_small}
                  value={startTime}
                  onChange={handleStartTimeChange}
                  ampm={false}
                />

                <Typography variant="caption" style={{ marginLeft: '20px', marginRight: '10px' }}>(<FormattedMessage id="wakeup_table_search_max_period" />)</Typography>

              </MuiPickersUtilsProvider>
            </MuiThemeProvider>
          </div>


          <Autocomplete
            id="select-room"
            options={roomList}
            className={classes.options}
            width={200}
            autoHighlight
            getOptionLabel={(option) => (option.roomName ? option.roomName : "")}
            getOptionSelected={(option, value) => option.roomName === value.roomName}
            value={getRoomName(selectedRoomId)}
            renderOption={(option) => (
              <React.Fragment>
                {option.roomName}
              </React.Fragment>
            )}

            renderInput={(params) => (
              <TextField
                {...params}
                label={formatMessage({ id: 'emergency_history_select_room' })}
                variant="outlined"
                // required
                inputProps={{
                  ...params.inputProps,
                  // autoComplete: 'new-password', // disable autocomplete and autofill
                }}
              />
            )}

            onChange={(event, newValue) => {
              if (newValue && newValue.roomId) {
                props.updateQueryWakeupRoomId(newValue.roomId);
                setSelectedRoomId(newValue.roomId);
              }
            }}
          />

          <FormGroup row >
            <FormControlLabel
              control={<Switch checked={checkedWakeup} onChange={handleCheckWakeup} name="checkEmergency" color="primary" />}
              label={formatMessage({ id: 'WAKEUP' })}
            />
            <FormControlLabel
              control={<Switch checked={checkedPresence} onChange={handleCheckPresence} name="checkCaution" color="primary" />}
              label={formatMessage({ id: 'PRESENCE' })}
            />
          </FormGroup>

          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.bulkAction}
            onClick={handleSearch}
          >
            {<FormattedMessage id="search" />}
          </Button>


          <Button
            variant="outlined"
            size="large"
            className={classes.bulkAction}
            onClick={handleClear}
          >
            {<FormattedMessage id="initialize" />}
          </Button>

        </Box>
      </Box>


      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>

            <Grid container spacing={1}>
              <Grid item lg={6} md={6} xs={6}>

                <Table>

                  <EnhancedTableHeader
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />

                  <TableBody>

                    {stableSort(firstHalfListData, getComparator(order, orderBy))
                      .slice(0 + firstHalfStartRow, firstHalfRowsPerPage + (firstHalfPage * firstHalfRowsPerPage))
                      .map((module, index) => {

                        return (
                          <TwoPartTable module={module} index={index} />
                        )
                      })
                    }

                  </TableBody>
                </Table>

                <CardActions className={classes.actions}>
                  <TablePagination
                    component="div"
                    count={firstHalfListData.length}
                    onPageChange={handleFirstHalfPageChange}
                    onRowsPerPageChange={handleFirstHalfRowsPerPageChange}
                    page={firstHalfPage}
                    rowsPerPage={firstHalfRowsPerPage}
                    rowsPerPageOptions={[5, 10, 25]}
                  />
                </CardActions>
              </Grid>


              <Grid item lg={6} md={6} xs={6}>

                <Table>

                  <EnhancedTableHeader
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />

                  <TableBody>

                    {stableSort(secondHalfListData, getComparator(order, orderBy))
                      .slice(0 + secondHalfStartRow, secondHalfRowsPerPage + (secondHalfPage * secondHalfRowsPerPage))
                      .map((module, index) => {

                        return (
                          <TwoPartTable module={module} index={index} />
                        )
                      })
                    }

                  </TableBody>
                </Table>

                <CardActions className={classes.actions}>
                  <TablePagination
                    component="div"
                    count={secondHalfListData.length}
                    onPageChange={handleSecondHalfPageChange}
                    onRowsPerPageChange={handleSecondHalfRowsPerPageChange}
                    page={secondHalfPage}
                    rowsPerPage={secondHalfRowsPerPage}
                    rowsPerPageOptions={[5, 10, 25]}
                  />
                </CardActions>
              </Grid>
            </Grid>

          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  );
};

WakeupList.propTypes = {
  className: PropTypes.string,
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateQueryWakeupStartDate,
    updateQueryWakeupStartTime,
    updateQueryWakeupRoomId,
    updateQueryCheckWakeup,
    updateQueryCheckPresence
   }, dispatch);
};

let mapStateToProps = (state) => {
  return {
    queryParams: state.queryParams,
    queryRowsPerPage: state.queryRowsPerPage
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WakeupList);



const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    // minWidth: 1050
  },
  actions: {
    justifyContent: 'flex-end'
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },

  input_container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  datepicker: {
    marginLeft: theme.spacing(1),
    maringRight: theme.spacing(1),
    width: 140,
  },
  textField: {
    marginLeft: theme.spacing(1),
    maringRight: theme.spacing(1),
    width: 120,
  },
  textField_small: {
    marginLeft: theme.spacing(1),
    maringRight: theme.spacing(1),
    width: 100,
  },
  options: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(3),
    width: 240,
  }
}));